import { PageData } from '@/app/types/cms';
import { CMSContainer } from '@/modules/CMSContainer';
import { NextSeo } from 'next-seo';
import Image from 'next/image';

import styles from './ReferAFriendPage.module.scss';
import ReferFriendDoctors from './assets/referFriendDoctors.png';
import { ReferFriendForm } from './components/ReferFriendForm/ReferFriendForm';
import { ReferFriendRules } from './components/ReferFriendRules/ReferFriendRules';

interface ReferAFriendPageProps {
  pageData: PageData;
  referralAmount?: string;
}

const ReferAFriendPage = ({ pageData, referralAmount }: ReferAFriendPageProps) => {
  const defaultTitle = 'Doctor Job Search';
  const defaultDescription = 'Discover the right doctor job for you in Australia or New Zealand';

  const renderedReferralAmount = referralAmount ?? '$1000';

  // TODO: Create new SEO component with adapter pattern so that we can simplify the NextSeo usage
  return (
    <CMSContainer>
      <NextSeo
        canonical={pageData.canonical_url}
        title={pageData.meta_title || defaultTitle}
        description={pageData.meta_description || defaultDescription}
        noindex={!pageData.index}
        nofollow={!pageData.index}
        openGraph={{
          title: pageData.meta_title || defaultTitle,
          description: pageData.meta_description || defaultDescription,
        }}
      />
      <div className={styles.referAFriendPage}>
        <div className={styles.pageContainer}>
          <div className={styles.contentContainer}>
            <div className={styles.textContainer}>
              <h1 className={styles.title}>
                <span>Refer a friend</span> and earn up to {renderedReferralAmount}*
              </h1>
              <p className={styles.description}>
                Help a friend find a great role, and get rewarded when they do, it’s a win-win. If
                you know a doctor looking for locum or permanent work, refer them to Medrecruit.
                Once they complete a placement, you’ll receive up to {renderedReferralAmount} as a
                thank you.
              </p>
            </div>
            <div className={styles.imageContainer}>
              <Image className={styles.image} src={ReferFriendDoctors} aria-hidden priority />
            </div>
          </div>
          <div className={styles.actionContainer}>
            <ReferFriendForm />
          </div>
        </div>
      </div>
      <ReferFriendRules referralAmount={renderedReferralAmount} />
    </CMSContainer>
  );
};

export default ReferAFriendPage;
